export default {
  init() {

  },
  finalize() {
    const $globalSearch = $('.global-search');
    const $searchResults = $globalSearch.find('.search-results');
    $globalSearch.css({ 'height': $(window).innerHeight() + 'px' });

    const $searchResultsSitesWrap = $globalSearch.find('.search-results-sites-wrap');

    $searchResultsSitesWrap.find('.search-site-btn[data-slug="current"]').on('click', function() {
      $searchResults.find('.search-results-wrap[data-name="current"]').removeClass('d-none');
      $searchResults.find('.search-results-wrap[data-name!="current"]').addClass('d-none');

      $(this).addClass('search-site-active');
      $searchResultsSitesWrap.find('.search-site-btn[data-slug!="current"]').each(function() {
        $(this).removeClass('search-site-active');
      });

      if ($globalSearch.find('.search-results-null').hasClass('visible-temp')) {
        $globalSearch.find('.search-results-null').removeClass('visible-temp').show();
      }
    });

    var totalResults = 0;

    function doSearch(query) {
      totalResults = 0;

      $searchResultsSitesWrap.find('.search-site-btn').each(function() {
        $(this).find('.search-site-results').html('0');

        if ($(this).data('slug') == 'current') {
          $(this).addClass('search-site-active');
        } else {
          $(this).removeClass('search-site-active');
          $(this).addClass('search-site-empty');
        }
      });

      $searchResultsSitesWrap.show();

      $globalSearch.find('.search-results-searching').addClass('show');
      $globalSearch.find('.search-results-searching .search-result-placeholder').removeClass('hide').addClass('show');

      // Remove non-current results wraps
      $searchResults.find('.search-results-wrap[data-name!="current"]').remove();
      $searchResults.find('.search-results-wrap[data-name="current"]').removeClass('d-none');

      // Clear the results wrap
      $globalSearch.find('.search-results-wrap').empty();
      $globalSearch.find('.search-results-wrap').addClass('hide');

      $globalSearch.find('.search-results-searching').addClass('show');
      $globalSearch.find('.search-results-null').removeClass('visible-temp');

      if (query == '') {
        // No input, reset the screen. Show the suggest searches.
        $globalSearch.find('.search-featured').show().removeClass('hide');
        $globalSearch.find('.search-results-label').addClass('hide').hide();
        $globalSearch.find('.search-results-null').addClass('hide').hide();
      } else {
        // Hide the suggested searches
        $globalSearch.find('.search-featured').addClass('hide');
        $globalSearch.find('.search-results-label').addClass('hide').hide();
        $globalSearch.find('.search-results-null').addClass('hide').hide();

        // Wait for the suggested searches to finish hiding.
        setTimeout(() => {

          $globalSearch.find('.search-featured').hide();
          $globalSearch.find('.search-results-wrap').hide();

          // Get all microsites
          $.ajax({
            url: $globalSearch.data('remote-api') + '/wp-json/microsite-search-endpoints/get',
            data: {
              omit: 'yr-ysgwrn',
            },
            method: 'GET',
          }).done(function(e) {

            if (Array.isArray(e)) {
              const expectedOrder = [
                'national-park',
                'park-authority',
                'planning-and-development',
                'yr-ysgwrn',
                'management-plan',
              ];

              // Ensure array is in the correct order the e.slugs array is not always in the correct order.
              const sortedResponse = [];
              expectedOrder.forEach((slug) => {
                const found = e.find((item) => {
                  return item.slug == slug;
                });

                if (found) {
                  sortedResponse.push(found);
                }
              });

              sortedResponse.forEach((microsite) => {
                // Add a wrap for the microsite
                const $micrositeSearchWrap = $(`<div class="search-results-wrap d-none" data-name="${microsite.slug}"></div>`);
                $searchResults.append($micrositeSearchWrap);

                if ($searchResultsSitesWrap.find(`.search-site-btn[data-slug="${microsite.slug}"]`).length == 0) {
                  const $searchSiteBtn = $(`<button type="button" class="btn search-site-btn search-site-empty" aria-label="${microsite.title}" data-slug="${microsite.slug}">
                    <span class="search-site-name">${microsite.title}</span>
                    <span class="search-site-results">0</span>
                    </button>`);

                  $searchResultsSitesWrap.append($searchSiteBtn);

                  $searchSiteBtn.on('click', function() {
                    if (!$(this).hasClass('search-site-empty')) {
                      const tabname = $(this).data('slug');
                      $searchResults.find(`.search-results-wrap[data-name="${tabname}"]`).removeClass('d-none');
                      $searchResults.find(`.search-results-wrap[data-name!="${tabname}"]`).addClass('d-none');

                      $(this).addClass('search-site-active');
                      $searchResultsSitesWrap.find(`.search-site-btn[data-slug!="${tabname}"]`).each(function() {
                        $(this).removeClass('search-site-active');
                      });

                      if ($globalSearch.find('.search-results-null').is(':visible')) {
                        $globalSearch.find('.search-results-null').addClass('visible-temp').hide();
                      }
                    }
                  });
                }

                // Run API call to this microsite to retrieve results
                $.ajax({
                  url: microsite.endpoint,
                  method: 'GET',
                  data: {
                    q: query,
                    lang: $('html').attr('lang') == 'en-US' ? 'en' : 'cy',
                  },
                }).done(function(m_e) {
                  renderResults(m_e, query, microsite.slug);
                });
              });
            }

          });

          // While all that happens get the results from this site.
          $.ajax({
            url: '/wp-json/search/v1/get',
            method: 'GET',
            data: {
              q: query,
              lang: $('html').attr('lang') == 'en-US' ? 'en' : 'cy',
            },
          }).done(function(e) {
            renderResults(e, query);
          });

        }, 400);
      }
    }

    // Form submit
    $globalSearch.find('#search-form').on('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      doSearch($globalSearch.find('#search-form .search-input').val());
    });

    // Featured search click
    $globalSearch.find('.featured-search-keyword').on('click', function() {
      $globalSearch.find('#search-form .search-input').val($(this).data('keyword'));
      doSearch($(this).data('keyword'));
    });

    // Close the dialogue
    $globalSearch.find('.search-close').on('click', function() {
      $globalSearch.removeClass('show');
      $('body').removeClass('overflow-hidden');

      // Reset the dialogue
      $globalSearch.find('.search-results-wrap').empty();
      $globalSearch.find('.search-featured').show().removeClass('hide');
      $globalSearch.find('.search-results-label').hide().addClass('hide');
      $globalSearch.find('.search-results-null').hide().addClass('hide');
      $globalSearch.find('.search-input').val('');

      $searchResultsSitesWrap.hide();
    });

    function renderResults(e, query, tabName = 'current') {
      const $searchWrap = $searchResults.find(`.search-results-wrap[data-name="${tabName}"]`);

      if (Array.isArray(e)) {
        totalResults += e.length;

        $globalSearch.find('.search-results-label .search-results-quantity').html(totalResults);
        $globalSearch.find('.search-results-label .search-results-query').html(`'${query}'`);

        const $theSiteButton = $searchResultsSitesWrap.find(`.search-site-btn[data-slug="${tabName}"]`);

        if (e.length == 0) {
          if (tabName != 'current') {
            $theSiteButton.addClass('search-site-empty');
          }
        } else {
          $theSiteButton.removeClass('search-site-empty');
        }

        $theSiteButton.find('.search-site-results').html(e.length);

        if (e.length == 0) {
          $globalSearch.find('.search-results-searching').removeClass('show');

          if (tabName == 'current') {
            // No results.
            $globalSearch.find('.search-results-null').show().removeClass('hide');
            $globalSearch.find('.search-results-null .search-results-null-query').html(`'${query}'`);
            $globalSearch.find('.search-featured').show().removeClass('hide');
          }
        } else {
          $globalSearch.find('.search-results-label').show().removeClass('hide');

          if (e.length == 1) {
            $globalSearch.find('.search-results-for').addClass('d-none');
            $globalSearch.find('.search-result-for').removeClass('d-none');
          } else {
            $globalSearch.find('.search-results-for').removeClass('d-none');
            $globalSearch.find('.search-result-for').addClass('d-none');
          }

          e.forEach((searchResult, i) => {
            const $searchResult = $globalSearch.find('.search-result-dummy').clone().appendTo($searchWrap);
            $searchResult.find('.search-result-link').prop('href', searchResult.link);
            $searchResult.find('.search-result-link').attr('aria-label', searchResult.title);

            if (tabName != 'current') {
              $searchResult.find('.search-result-link').prop('target', '_blank');
              $searchResult.addClass('external');
            }

            if (searchResult.thumb !== false) {
              $searchResult.find('.search-result-image').prop('src', searchResult.thumb);
              $searchResult.find('.search-result-image').prop('alt', searchResult.title);
            } else {
              $searchResult.find('.search-result-image').hide();
            }

            if(searchResult.post_type == 'resource') {
              const docIconHtml = '<i class="icon-flexible-download-white"></i>';
              $searchResult.find('.search-result-go').html(docIconHtml);

              $searchResult.find('.search-result-image-wrap').addClass('search-result-doc-icon');
            }

            $searchResult.find('.search-result-title').html(searchResult.title);
            $searchResult.removeClass('search-result-dummy').addClass('search-result');
            // $searchResult.css({ 'transition-delay': (0.25 * i) + 's' });

            setTimeout(() => {
              $searchResult.addClass('show');
            }, 500);
          });

          if (tabName == 'current') {
            $globalSearch.find($searchWrap).show().removeClass('hide');
          }
        }

        $globalSearch.find('.search-results-searching .search-result-placeholder').addClass('hide');
        // $globalSearch.find('.search-results-searching').removeClass('show');

      }
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/partials/other/globalSearch.js